import { render } from "./AboutUsPage.vue?vue&type=template&id=276c3c02&scoped=true"
import script from "./AboutUsPage.vue?vue&type=script&lang=js"
export * from "./AboutUsPage.vue?vue&type=script&lang=js"

import "./AboutUsPage.vue?vue&type=style&index=0&id=276c3c02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276c3c02"]])

export default __exports__